export const PDF_MIME_TYPE = 'application/pdf';

export const OBJECT_TYPE_IMAGE = 'image';
export const OBJECT_TYPE_TEXT = 'text';
export const OBJECT_TYPE_DRAWING = 'drawing';
export const OBJECT_TYPE_SHAPE = 'shape';

export const DEFAULT_FONT_FAMILY = '標楷體';
export const DEFAULT_TEXT_VALUE = '新增文字內容';
export const DEFAULT_TEXT_FONT_SIZE = 16;
export const DEFAULT_TEXT_LINE_HEIGHT = 1.4;

export const MAX_OBJECT_DIMENSION = 500;